export * from "/codebuild/output/src1269516410/src/dgbet/local_modules/wallet/index.ts"